var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-team grey-bg"},[_c('div',{staticClass:"iq-team-img"},[_vm._t("cardMedia")],2),_vm._v(" "),_c('div',{staticClass:"iq-team-info text-center"},[_vm._t("cardHeader")],2),_vm._v(" "),_c('div',{staticClass:"share"},[_vm._t("cardOverlay")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }